export default __webpack_public_path__ + "static/media/See_more.7a38e50d.svg";